module.exports = __webpack_public_path__ + "img/prod-icon4.cf837cb9.png";